module.exports = __webpack_public_path__ + "495c4825f811a65d68d9973f20a06b98.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/news2-thumb.jpg
 ** module id = 515
 ** module chunks = 1
 **/